import React, {
  useRef,
  useCallback,
  useEffect,
  useState,
  MutableRefObject,
} from 'react'

interface MarvinJSProps {
  marvinStyle: string
  marvinSketch: MutableRefObject<unknown>
  setMarvinSketchReady: (boolean) => void
}
const MarvinJS: React.FC<MarvinJSProps> = ({
  marvinStyle,
  marvinSketch,
  setMarvinSketchReady,
}) => {
  const marvinJsIframe = useRef<HTMLIFrameElement | undefined | null>()
  const [iframeHasMarvinRef, setIframeHasMarvinRef] = useState(false)
  const restartTimer = (callback) => setTimeout(callback, 50)

  const checkIfReady = useCallback(() => {
    const marvinRef = marvinJsIframe.current
    /** need to run through all these checks because instantiating the marvin
     * api requires many async iframe and subsequent marvin props to be loaded
     * before the api can be reliably accessed
     */
    if (!marvinRef) {
      restartTimer(checkIfReady)
      return
    }
    setIframeHasMarvinRef(true)

    const iframeWin = marvinRef.contentWindow
    if (!iframeWin) {
      restartTimer(checkIfReady)
      return
    }

    // @ts-ignore
    const marvin = iframeWin.marvin
    if (!marvin) {
      restartTimer(checkIfReady)
      return
    }
    marvin.onReady(() => {
      // @ts-ignore
      if (typeof marvin.sketcherInstance !== 'undefined') {
        // undefined if you dont have permissions to access it or instantiation failed
        // @ts-ignore
        marvinSketch.current = marvin.sketcherInstance
        // lets parent component know to enable search button
        setMarvinSketchReady(true)
      }
    })
    // TODO: need a test before we refactor these dependencies
  }, [])

  // this extra check to re-run the checkIfReady if not correctly run on load
  useEffect(() => {
    if (!iframeHasMarvinRef) {
      restartTimer(checkIfReady)
    }
    // TODO: need a test before we refactor these dependencies
  }, [iframeHasMarvinRef])

  return (
    <>
      <iframe
        title="marvinJs-sketch"
        id="iframe--marvinjs"
        tabIndex={-1}
        //@ts-ignore
        ref={marvinJsIframe}
        src="/static/vendor/marvinjs/editor.html"
        className={marvinStyle}
        onLoad={checkIfReady}
      />
    </>
  )
}

export default MarvinJS
